import { IoClose } from 'react-icons/io5';
import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5); /* 배경을 어둡게, 반투명으로 설정 */
  z-index: 97; /* 모달보다 뒤에 위치하도록 */
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`;

export const CloseButtonBox = styled.div`
  font-size: 3rem;
  padding: 0.4rem;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.gray300};
    color: ${(props) => props.theme.colors.white};
  }
`;

export const Circle = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.main};
`;

export const EventModalWrap = styled.div`
  z-index: 98;
  position: fixed;
  top: 40%;
  left: 50%;
  overflow: auto;
  max-height: 60rem;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 60rem;
  min-width: 47rem;
  background: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.txt400};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  box-sizing: border-box;
  scale: 0.9;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1rem;

  > h3 {
    font-size: 2rem;
    font-weight: 900;
    margin-bottom: 1rem;
    > strong {
      color: ${(props) => props.theme.colors.main};
    }
  }

  > div {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    color: ${(props) => props.theme.colors.txt500};
    font-size: 1.6rem;
    font-weight: 500;
    strong {
      font-weight: 800;
    }

    // 010 ~ 얼마 015 얼마
    > div {
      font-size: 2.4rem;
      display: flex;
      gap: 1rem;
      align-items: center;

      strong {
        font-weight: 900;
      }

      span {
        color: ${(props) => props.theme.colors.main};
      }
    }
  }
`;

export const DashedLine = styled.div`
  display: flex; /* Flexbox 사용 */
  justify-content: center; /* 가로 중앙 정렬 */
  align-items: center; /* 세로 중앙 정렬 (필요 시 추가) */
  width: 100%; /* 부모 컨테이너 너비 채우기 */
  height: 2px; /* 라인의 두께 */
  border-top: 2px dashed ${(props) => props.theme.colors.gray200}; /* 점선 스타일 */
  margin: 10px 0; /* 위아래 여백 (필요 시) */
`;

export const ModalButtonContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  > button {
    padding: 1.4rem;
    width: 22rem;
    border-radius: 1rem;
    font-size: ${(props) => props.theme.fontSize.title16};
    font-weight: ${(props) => props.theme.fontWeight.bold};

    &:nth-child(1) {
      background-color: ${(props) => props.theme.colors.main};
      color: ${(props) => props.theme.colors.white};

      &:hover {
        background-color: ${(props) => props.theme.colors.activeMain};
        color: ${(props) => props.theme.colors.white};
      }
    }

    &:nth-child(2) {
      border: 1px solid ${(props) => props.theme.colors.main};
      color: ${(props) => props.theme.colors.main};

      &:hover {
        background-color: ${(props) => props.theme.colors.activeMain};
        color: ${(props) => props.theme.colors.white};
      }
    }
  }
`;

export const Payment = styled.div`
  display: flex;
  gap: 5px;
  width: 100%;
  padding: 0.8rem;
  background: ${(props) => props.theme.colors.gray200};
  border-radius: 1rem;
  button {
    cursor: pointer;
    width: 25%;
    padding: 1rem;
    font-size: 1.6rem;
    color: ${(props) => props.theme.colors.txt200};
    transition: all 0.2s ease-in;
  }
  button:hover {
    border-radius: 6px;
    background: ${(props) => props.theme.colors.gray700};
    color: ${(props) => props.theme.colors.txt100};
  }
  button.active {
    border-radius: 6px;
    background: ${(props) => props.theme.colors.main};
    color: ${(props) => props.theme.colors.txt100};
  }
  @media screen and (max-width: 760px) {
    flex-wrap: wrap;
    gap: 1rem;
    button {
      width: calc(50% - 0.5rem);
    }
  }
  @media screen and (max-width: 540px) {
    button {
      width: 100%;
    }
  }
`;

export const Guide = styled.ul`
  > li {
    font-size: 1.4rem;
    color: ${(props) => props.theme.colors.txt300};
    font-weight: 500;
    margin-bottom: 2rem;
  }
  > p {
    margin-top: 3rem;
    font-size: 1.4rem;
    color: ${(props) => props.theme.colors.main};
    line-height: 1.8em;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: stretch; /* 모든 자식 요소 높이 동일 */
  width: 100%;
  height: 100%;
`;

export const Card = styled.div`
  box-shadow: 0 0.2rem 0.6rem 0 rgba(0, 0, 0, 0.1);
  border-radius: 1rem;
  width: 100%;
  height: auto; /* 높이를 컨텐츠에 맞춤 */
  color: ${(props) => props.theme.colors.txt200};
  padding: 2rem;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  gap: 2rem;

  cursor: pointer;
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.buttonActiveBg};
  }
`;

export const Header = styled.div`
  color: ${(props) => props.theme.colors.txt200};
  font-size: 1.4rem;

  > h3 {
    font-size: 2rem;
    font-weight: 700;
    color: ${(props) => props.theme.colors.txt400};
  }
`;

export const Main = styled.div`
  color: ${(props) => props.theme.colors.txt200};

  > div {
    font-size: 1.4rem;
    margin-bottom: 0.8rem;
    > strong {
      font-size: 3rem;
      color: ${(props) => props.theme.colors.txt400};
      font-weight: 700;
    }
  }
`;

export const ButtonWrap = styled.div`
  button {
    width: 100%;
    font-size: 1.4rem;
    padding: 2rem;
    margin-bottom: 1rem;
  }
  .checkbox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.8rem;
    font-size: 1.4rem;
    font-weight: bold;
    div {
      text-decoration: underline;
      :hover {
        color: ${(props) => props.theme.colors.main};
      }
    }
  }
`;

export const Button = styled.button`
  background-color: ${(props) => props.theme.colors.gray300};
  color: ${(props) => props.theme.colors.white};
  padding: 2rem;
  border-radius: 1rem;

  ${Card}:hover & {
    background-color: ${(props) => props.theme.colors.buttonActiveBg};
    color: ${(props) => props.theme.colors.txt100};
  }
`;

export const CheckContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.8rem;
`;

export const Check = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.4rem;
  gap: 1rem;
`;
